import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import arrowForwardImg from "../images/arrow-forward.svg"
import checkmarkImg from "../images/checkmark.b8187469.svg"
import uploadFolderImg from "../images/upload-folder.svg"
import linkedinImg from "../images/linkedin.svg"
import $ from 'jquery';
import { storage } from "../firebase";
import moment from 'moment';
import { guidance, database } from '../firebase'
export default class AssesmentApply2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Subject: "",
      expertise: "",
      Skills: "",
      experience: "",
      education: "",
      currentSalary:"",
      BudgetConstriction: "",
      checkBoxValue: '',
      expertiseData: [],
      experienceData: [],
      educationData: [],
      resumeImage: null,
      url: null,
      resumeLink: "",
      personna: "",
      expertiseFlag:false
    }
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeChk = this.handleChangeChk.bind(this);
  }
  handleChangeChk = (e) => {
    let isChecked = e.target.value;
    console.log("isChecked...",isChecked)
    if(isChecked == "No"){
      this.setState({
        expertiseFlag:false
      })
    }
    else{
      this.setState({
        expertiseFlag:true
      })
    }
    this.setState({
      checkBoxValue: isChecked
    });
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };
  renderList() {
    console.log('fooooo', localStorage.getItem("guidanceArray"))
    
    let data = JSON.parse(localStorage.getItem("guidanceArray"))
    console.log("data....",data)
    //alert(data.Expertise)
    if(data){
    $("#expertise").val(data.Expertise)
    $("#experience").val(data.Experience)
    $("#currentSalary").val(data.currentSalary)
    $("#education").val(data.Education)
    $("#resumeLink").val(data.resumeLink)
    this.setState({ expertise: data.Expertise, experience: data.Experience, education: data.Education, resumeLink: data.resumeLink,currentSalary:data.currentSalary })
    }
  }
  async componentDidMount() {
    console.log('fooooo1', localStorage.getItem("personna"))
    let expertiseList = [];
    let experienceList = [];
    let educationList = [];
    await database.ref("expertise").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          expertiseList.push({
            key: ChildSnapshot.key,
            expertise: ChildSnapshot.val().expertise
          });
        }
      });
    });
    this.setState({
      expertiseData: expertiseList
    });
    await database.ref("experience").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          experienceList.push({
            experience: ChildSnapshot.val().experience
          });
        }
      });
    });
    this.setState({
      experienceData: experienceList
    })
    await database.ref("education").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          educationList.push({
            education: ChildSnapshot.val().education
          });
        }
      });
    });
    this.setState({
      educationData: educationList
    })

    this.renderList()
  }
  handleImageChange = e => {
    if (e.target.files[0]) {
      this.setState({
        resumeImage: e.target.files[0],
        fileName: true

      })
    }
  };
  updateValidateSubmission = () => {
    if (this.state.expertise === "") {
      alert("Expertise required")
      return false;
    }
    else if (this.state.experience === "") {
      alert("Experience required")
      return false;
    }
    else if (this.state.currentSalary === "" && this.state.experience != "0-1") {
      alert("Current Salary required")
      return false;
    }
    else if (this.state.fileName === true) {
      const uploadTask = storage.ref(`Guidance/${this.state.resumeImage.name}`).put(this.state.resumeImage);
      uploadTask.on(
        "state_changed",
        snapshot => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          this.setState({
            progress: progress
          })
        },
        error => {
          console.log(error);
        },
        () => {
          storage
            .ref("Guidance")
            .child(this.state.resumeImage.name)
            .getDownloadURL()
            .then(url => {
              console.log("url...", url)
              $("#imageUrl")
                .attr('src', url);
              this.setState({
                url: url
              });
              this.updateData()
            });
        }
      );

    }
    else {
      if (this.state.currentSalary === ""){
        this.setState({
          currentSalary : 0
        })
      }
      this.updateData()
    }

  }
  updateData() {

    let progressInfo = localStorage.getItem("progressInfo")
    progressInfo = parseInt(progressInfo)
    if (this.state.expertise != "") { progressInfo = progressInfo + 5 }
    if (this.state.experience != "") { progressInfo = progressInfo + 5 }
    if (this.state.education != "") { progressInfo = progressInfo + 5 }
    if (this.state.url != "" || this.state.resumeLink != "") { progressInfo = progressInfo + 5 }
    localStorage.setItem("progressInfo", progressInfo)
    const dataSet = {
      //Subject: this.state.Subject,
      Expertise: this.state.expertise,
      //Skills:this.state.Skills,
      Experience: this.state.experience,
      currentSalary : this.state.currentSalary,
      Education: this.state.education,
      // BudgetConstriction:this.state.BudgetConstriction,
      resumeFile: this.state.url === null ? "" : this.state.url,
      resumeLink: this.state.resumeLink,
      progressInfo: progressInfo,
      expertiseFlag:this.state.expertiseFlag,
      step3: "true",
    }
    console.log("dataSet....", dataSet)
    database.ref(`Guidance/${this.props.match.params.key}`).update(dataSet).then(() => {
      localStorage.setItem("userExpertise", this.state.expertise)
      window.location.href = "/assesment/apply-4/id=" + this.props.match.params.key

    }).catch(() => {
      alert("Somthing went wrong")
    })
  }
  render() {

    return (

      <div className="main-wrapper assesment-wrapper">
        <Header></Header>
        <div className="main-content" style={{ background: "#f4f6f9" }}>
          <div className="container p-0 pt-5">
            <div className='row'>
              <div className='col-lg-6 m-auto p-0'>
                <form className='form-main-wrapper'>
                  <div className='form-group progress-det'>
                    <div className="form-group subhead">What are you up to so far?</div>
                    {/* <span className='progress-content'>Step 2/5 : Professional</span> */}
                    {/* <div className="progress">
                        <div className="progress-bar" role="progressbar" style={{width:"30%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                      </div> */}
                  </div>
                  <hr></hr>
                  {/* <div className="form-group">
                      <label for="exampleFormControlInput1">Subject </label>
                      <input type="text" className="form-control" name="Subject" id="Subject" onChange={this.handleChange} />
                    </div> */}
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Expertise<span style={{ color: "#535fe5" }}>*</span></label>
                    {localStorage.getItem("personna") !== "I'm a fresh graduate out of college. I'm looking for a course to kickstart my career with."?
                    <div className='row' onChange={this.handleChangeChk}>
                      <label for="goal">Do you want to learn new skills from your current expertise?</label>
                      <label for="goalChk" className="label-radio" style={{ width: "100px" }}>
                        <input checked={this.state.checkBoxValue === "Yes"} name="goalChk" id="goalChk" type="radio" value="Yes" />
                        <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                        <span>Yes</span>
                        <div className="label-radio-checkedBackground"></div>
                      </label>
                      <label for="goalChk" className="label-radio" style={{ width: "100px" }}>
                        <input checked={this.state.checkBoxValue === "No"} name="goalChk" id="goalChk" type="radio" value="No" />
                        <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                        <span>No</span>
                        <div className="label-radio-checkedBackground"></div>
                      </label>
                    </div>
                    :""}
                    <select className="form-control" onChange={this.handleChange} id="expertise" name="expertise">
                      <option key="" value="" >Select Expertise</option>
                      {
                        this.state.expertiseData.map((x, y) =>
                          <option key={y}>{x.expertise}</option>)
                      }</select>



                  </div>
                  {/* <div className="form-group">
                      <label for="exampleFormControlInput1"> Skills</label>
                      <input type="text" className="form-control" id="Skills" name="Skills" onChange={this.handleChange}/>
                    </div> */}
                  <div className="form-group">
                    {/* <input type="text" className="form-control" id="Experience" name="Experience" onChange={this.handleChange} /> */}
                    <label for="exampleFormControlInput1">Experience<span style={{ color: "#535fe5" }}>*</span></label>
                    <select className="form-control" onChange={this.handleChange} id="experience" name="experience">
                      <option key="" value="">Select Experience</option>
                      {
                        this.state.experienceData.map((x, y) =>
                          <option key={y}>{x.experience}</option>)
                      }</select>
                    {/* <div className='row'>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="Yes"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="1to3" src={checkmarkImg} />
                          <span>1-3</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                        <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                          <input name="authorized_usa" id="authorized_usa" type="radio" value="No"  onChange={this.handleChange} />
                          <img className="label-radio-img" alt="2to3" src={checkmarkImg} />
                          <span>2-3</span>
                          <div className="label-radio-checkedBackground"></div>
                        </label>
                      </div> */}
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Current Salary<span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="text" name="currentSalary" id="currentSalary" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1"> Education</label>
                    <select className="form-control" onChange={this.handleChange} id="education" name="education">
                      <option key="" value=""> Select Education</option>
                      {
                        this.state.educationData.map((x, y) =>
                          <option key={y}>{x.education}</option>)
                      }</select>
                    {/* <input type="text" className="form-control" id="Education" name="Education" onChange={this.handleChange}/> */}
                    {/* <div className='row'>
                        <div className='col-md-4'>
                          <input type="checkbox"/> Bachelor
                        </div>
                        <div className='col-md-4'>
                          <input type="checkbox"/> Master
                        </div>
                      </div> */}
                  </div>
                  {/* <div className="form-group">
                      <label for="exampleFormControlInput1"> Budget Constriction</label>
                      <input type="text" className="form-control" name="BudgetConstriction" id="BudgetConstriction" onChange={this.handleChange}/>
                    </div> */}
                  <div className='form-group subhead text-left'>Share your profile</div>
                  <div className="form-group">
                    <p>To move forward with our course recommendation process, we ask that you share either your resume or a LinkedIn profile.  <span className='text-danger'>*</span></p>
                  </div>
                  <div className="form-group">
                    <label for="resumeImage" className="form-fileUpload">
                      <input name="resumeImage" id="resumeImage" type="file" onChange={this.handleImageChange} accept=".pdf,.doc,.docx" />
                      <div className="FormFileUpload_uploadContent__1quqH">
                        <img alt="Resume Upload" src={uploadFolderImg} />
                        <span className="form-fileUpload-title">Resume Upload</span>
                        <span className="form-fileUpload-helpText">.pdf, .doc, or .docx</span>
                      </div>
                    </label>
                  </div>
                  <div className="form-group text-center">
                    <label>OR</label>
                  </div>
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-text">
                        <img src={linkedinImg}></img>
                      </span>
                      <input type="text" onChange={this.handleChange} className="form-control" name="resumeLink" id="resumeLink" placeholder="https://linkedin.com/in/profile" />
                    </div>
                  </div>
                  <div className="form-group mt-4">
                    <a href="#" className="btn btn-gray w-100" onClick={() => this.updateValidateSubmission()}>
                      Next <img src={arrowForwardImg} className="arrow-filter"></img>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ivano/assesment-apply2.jsx